<template>
    <div class="fluid fill-height fill-width">
        <div class="error-container" v-bind:style="{right: (fullWidth) ? '0' : '500px'}">

            <!--<img src="/images/sad.svg" class="sad-face"/>-->

            <p class="display-1 mt-5">
                {{$t("We don't have an online viewer for this file format.")}}
            </p>
            <p class="display-1 mb-2">
                {{$t("But you can still download the file.")}}
            </p>

            <v-btn @click="downloadFile"
                    :loading="downloading"
                    :disabled="downloading"
                    color="primary"
                    class="ma-2 white--text"
            >
                Download
                <v-icon right dark>cloud_download</v-icon>
            </v-btn>

        </div>
    </div>
</template>

<script>
    import { VBtn,VIcon } from 'vuetify/lib'
    import FilesRepository from '../repositories/FilesRepository';

    export default {
        name: 'ViewerError',
        components: {
            VBtn, FilesRepository, VIcon
        },
        props: {
            fullWidth: Boolean,
            file: Object,
        },
        created() {
            this.$root.$on('downloaded-file', (event) => {
                this.downloading = false;
            });
        },
        data () {
            return {
                requesting: false,
                downloading: false
            }
        },
        methods: {
            downloadFile() {
                this.downloading = true;
                this.$root.$emit('download-file');
            },
        }
    };
</script>

<style scoped>
    .error-container {
        left: 0;
        top: 64px;
        bottom: 0;
        position: absolute;
        height: calc(100% - 64px);
        padding-top: 10px;
    }
    .sad-face{
        max-width: 180px;
        margin-bottom: 15px;
        margin-top: 15px;
    }
</style>
